














import { CategoryItem } from '@/interfaces/category-item';
import CategoryServices, { CategoryDto } from '@/services/category';
import IndicatorSetServices from '@/services/indicatorSet';
import { Vue, Component } from 'vue-property-decorator';
import RuleMenu from './rule-menu.vue';
import IndMenu from './ind-menu.vue';
import { namespace, State } from 'vuex-class';
import { mixins } from 'vue-class-component';
import MenuMixin from '@/mixins/menu-mixin';
const System = namespace('System');

@Component({
  components: { RuleMenu, IndMenu }
})
export default class Left extends mixins(MenuMixin) {
  @State MENU_INDENT: any;
  categorySrv = new CategoryServices();
  indSrv = new IndicatorSetServices();

  selectedKeys = [];
  keyword = '';
  current = 0;
  expand = true;
  indent = false;
  visible = false;
  activeKey = 'params';
  
  menu: CategoryItem[] = [
    {
      title: '参照库',
      icon: 'fa-cubes',
      oprate: false,
      expand: true,
      children: []
    }
  ];

  created() {
    this.initMenu();
  }

  initMenu() {
    if (this.ROLE_MENU.length === 0) {
      setTimeout(() => {
        this.initMenu();
      }, 100);
    } else {
      this.MENU('SUBJECT') && this.menu[0].children.push({ title: '主题表', key: '/decision/subject', oprate: false, icon: 'fa-cube' });
      this.MENU('DIMENSION') && this.menu[0].children.push({ title: '维度表', key: '/decision/dimension', oprate: false, icon: 'fa-cube' });
      this.MENU('DICTIONARY') && this.menu[0].children.push({ title: '字典集', key: '/decision/dict', oprate: false, icon: 'fa-cube' });
      this.MENU('PARAM') && this.menu[0].children.push({ title: '参数集', key: '/decision/params', oprate: false, icon: 'fa-cube' });
    }
  }

  onSearch() {}

  @System.State leftMenuIndent: any;
  @System.Mutation setLeftMenuIndent: any;
  @System.State activeTabs: any;
  @System.Mutation setActiveTabs: any;

  switchIndent() {
    this.setLeftMenuIndent();
  }

  update(key: string) {
    if (/\/decision/.test(key)) {
      let index = this.activeTabs.findIndex((v: any) => v.path.startsWith(key));
      if (index > -1) {
        this.setActiveTabs(this.activeTabs[index]);
        this.$router.push(this.activeTabs[index].fullPath);
      } else {
        this.$router.push(key);
      }
    }
  }
}
